
import React from 'react';

interface JsonOutputProps {
  data: any;
}

const JsonOutput: React.FC<JsonOutputProps> = ({ data }) => {
  const copyToClipboard = () => {
    navigator.clipboard.writeText(JSON.stringify(data, null, 2));
    alert('Copied to clipboard!');
  };

  return (
    <div className="relative">
      <button 
        onClick={copyToClipboard}
        className="absolute right-4 top-4 px-3 py-1 text-xs bg-slate-700 text-white rounded hover:bg-slate-600 transition-colors"
      >
        Copy JSON
      </button>
      <pre className="bg-slate-900 text-green-400 p-6 rounded-xl overflow-auto max-h-[600px] text-sm font-mono leading-relaxed border border-slate-800 shadow-inner">
        {JSON.stringify(data, null, 2)}
      </pre>
    </div>
  );
};

export default JsonOutput;
